import React, {
  useState,
  useCallback,
  useContext,
} from 'react';

import useToast from '../../../../../hooks/useToast';
import ExternalCoachContext from '../../../../../context/ExternalCoachContext';
import { ColorModes } from '../../../../../../Model/Coach';
import { SaveButton } from '../../../../../../components/Button/ActionButtons';
import InputLabel from '../../../../../../components/v2/InputLabel';
import RadioButtonGroup from '../../../../../components/RadioButtonGroup';
import {
  Card,
  Container,
  HeaderContainer,
  Title,
  TitleContainer,
} from '../../../../../../components/v2/Card';

import { SaveButtonContainer } from './styles';
import texts from './texts.json';

const ColorModeSetting = () => {
  const { coachDoc } = useContext(ExternalCoachContext);
  const [checkoutPageColorMode, setCheckoutPageColorMode] = useState(coachDoc.checkoutPageColorMode);

  const { showToast } = useToast();

  const onSaveColorMode = useCallback(async () => {
    if (!checkoutPageColorMode) {
      showToast(texts.colorModeNotSelected, { error: true });
      return;
    }
    await coachDoc.setCheckoutPageColorMode(checkoutPageColorMode);

    showToast(texts.colorModeSaved);
  }, [
    checkoutPageColorMode,
    coachDoc,
    showToast,
  ]);

  return (
    <Card>
      <HeaderContainer>
        <TitleContainer>
          <Title>{texts.checkoutPageColorMode}</Title>
        </TitleContainer>
      </HeaderContainer>
      <Container>
        <InputLabel>{texts.colorMode}</InputLabel>
        <RadioButtonGroup
          options={[
            {
              label: texts.darkMode,
              value: ColorModes.DARK,
            },
            {
              label: texts.lightMode,
              value: ColorModes.LIGHT,
            },
          ]}
          selectedOption={checkoutPageColorMode}
          onOptionChange={setCheckoutPageColorMode}
        />
        <SaveButtonContainer>
          <SaveButton
            onClick={onSaveColorMode}
            full={false}
            disabled={coachDoc.checkoutPageColorMode === checkoutPageColorMode}
          >
            {texts.save}
          </SaveButton>
        </SaveButtonContainer>
      </Container>
    </Card>
  );
};

export default ColorModeSetting;
